import { extractValue } from "../../../../../../libs/utils";

export function hasPositiveNumber(value: unknown): boolean {
  const unwrapped = extractValue(value);
  if (unwrapped == null || unwrapped === "") return false;
  const numeric = Number(unwrapped);
  return Number.isFinite(numeric) && numeric > 0;
}
